import React, { FunctionComponent, useState } from 'react'
import { ISelectOption } from 'Frontend/scripts/models/forums.model'
import { Button } from 'react-bootstrap'
import MultiSelectComponent from 'Features/MultiSelectComponent/MultiSelectComponent'
import { useTranslation } from 'react-i18next'
import { useSearchContext } from './forumQAndAContext'

interface SearchFormProps {
  tags?: ISelectOption[]
}

const SearchForm: FunctionComponent<SearchFormProps> = ({ tags }) => {
  const { setQuery, setTags, state } = useSearchContext()
  const [searchQuery, setSearchQuery] = useState<string>(state.query)
  const { t } = useTranslation()

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault()
    setQuery(searchQuery as string)
  }

  return (
    <div className="mb-4 forums__search">
      <h2 className="forums__heading">{t('search-in-forum')}</h2>
      <form method="post" onSubmit={handleSubmit} className="hero__search-field">
        <div className="d-flex gap-3">
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              name="query"
              defaultValue={searchQuery as string}
              aria-label="Sökformulär"
              aria-describedby="id-search-button"
              onChange={(e) => setSearchQuery(e.target.value)}
            ></input>
            <Button variant="secondary" type="submit" className="forums__search-button" id="id-search-button">
              <i className="fa fa-search me-2"></i>
              {t('search')}
            </Button>
          </div>
        </div>
        {tags && tags.length > 0 && (
          <div className="mt-3">
            <h3 className="mb-2 h4">{t('questions-tagged-with')}:</h3>
            <MultiSelectComponent
              options={tags}
              addToUrl={true}
              onChange={(selectedTagIds) => {
                const isSelectedTags = selectedTagIds.map((item: ISelectOption) => item.value.toString())
                setTags(isSelectedTags)
              }}
            />
          </div>
        )}
      </form>
    </div>
  )
}

export default SearchForm
